import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4cc2c6a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "reportes" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-list",
    _mstvisible: "2"
  }),
  /*#__PURE__*/_createTextVNode(" Chat")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "username"
}, "Usuario:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "message"
}, "Mensaje:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus",
  _mstvisible: "2"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Agregar Mensaje ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mensajes", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_Navbar),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.message.username) = $event)),
                id: "username",
                type: "username",
                class: "form-control"
              }, null, 512), [
                [_vModelText, this.message.username]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.message.message) = $event)),
                id: "message",
                type: "message",
                class: "form-control"
              }, null, 512), [
                [_vModelText, this.message.message]
              ])
            ])
          ], 32),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.addMessage())),
            class: "btn btn-success btn-sm",
            type: "button"
          }, _hoisted_12)
        ])
      ]),
      _hoisted_13,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messages, (message, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(message), 1))
        }), 128))
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}